import { useEffect, useRef, useState } from "react"

declare global {
    interface Window {
        consentStudio: {
            loadDeclaration: () => void
        }
    }
}

export const CookieDeclaration = ({ className }: { className?: string }) => {
    const ref = useRef<HTMLDivElement>(null)
    const [i, setI] = useState(0)
    useEffect(() => {
        if (i > 30) {
            return
        }
        if (window?.consentStudio?.loadDeclaration) {
            if (ref.current?.childNodes?.length === 0) {
                window.consentStudio.loadDeclaration()
            }
        } else {
            console.log("Consent Studio is not loaded")
            const timer = setTimeout(() => {
                setI(i + 1)
            }, 2000)
            return () => clearTimeout(timer)
        }
    }, [i])

    return (
        <div className={className}>
            <div id="cs-declaration" ref={ref} />
        </div>
    )
}
